export const ACTION_LABELS: Record<string, string> = {
  "admin.login": "Operator signed in",
  "admin.logout": "Operator signed out",
  "admin.player.force_logout": "Player sessions ended",
  "admin.player.status": "Player status changed",
  "admin.player_case.create": "Player case created",
  "admin.player_case.note_add": "Case note added",
  "admin.player_case.update": "Player case updated",
  "admin.reauth": "Operator reauthenticated",
  "royal_spin.campaign.approve": "Royal Spin campaign approved",
  "royal_spin.campaign.create": "Royal Spin campaign created",
  "royal_spin.campaign.submit": "Royal Spin campaign submitted",
  "royal_spin.emergency.toggle": "Royal Spin emergency state changed",
};

export function titleCase(value: string) {
  return value.replace(/[._-]+/g, " ").replace(/\b\w/g, (character) => character.toUpperCase());
}

export function actionLabel(actionType: string) {
  return ACTION_LABELS[actionType] ?? titleCase(actionType.replace(/^admin\./, ""));
}

export function riskLevel(actionType: string): "High" | "Review" | "Info" {
  if (/force_logout|emergency|\.reject$|status|reversal|void|ban|suspend|close/i.test(actionType)) {
    return "High";
  }
  if (/\.approve$|\.initiate$|\.create$|\.update$|note_add|submit/i.test(actionType)) {
    return "Review";
  }
  return "Info";
}
